import styled from 'styled-components';

export const ModalBody = styled.div`
  padding-top: 8px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
`;

export const ModalSizer = styled.div`
  display: inline-block;
  width: fit-content;
  max-width: 90vw;
`;
